import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import type { PopoverCustomProps } from "../types/popover";

const PopoverCustom = ({
  open,
  onClose,
  yesNo,
  title,
  contents,
  locatorName,
  yesButtonName,
  noButtonName,
  buttonsDisabled = false,
  yesButtonDisabled = false,
  closeOnYes = true,
  children,
}: PopoverCustomProps) => {
  const handleClickYes = () => {
    if (buttonsDisabled || yesButtonDisabled) {
      return;
    }
    if (!yesNo) {
      return;
    }
    yesNo(true);
    if (closeOnYes) {
      onClose();
    }
  };

  const handleClickNo = () => {
    if (buttonsDisabled) {
      return;
    }
    if (!yesNo) {
      return;
    }
    yesNo(false);
    onClose();
  };

  return (
    <React.Fragment>
      <Dialog
        open={open}
        onClose={buttonsDisabled ? undefined : onClose}
        disableEnforceFocus
        disableAutoFocus
        disableRestoreFocus
        keepMounted
        container={() => document.body}
        {...{ name: `${locatorName}` }}
        sx={{ zIndex: 1500 }}
      >
        <Box
          sx={{
            display: "flex",
            height: "56px",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "8px",
            borderBottom: "2px solid #CCC",
            position: "sticky",
            top: 0,
            backgroundColor: "#fff",
            zIndex: 1,
          }}
        >
          <Box
            sx={{
              paddingLeft: "8px",
              fontWeight: "bold",
              fontSize: "20px",
            }}
          >
            {title}
          </Box>
          <IconButton
            aria-label="close"
            onClick={onClose}
            disabled={buttonsDisabled}
            sx={{
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </Box>
        <Box sx={{ padding: "16px", fontWeight: "bold" }}>{contents}</Box>
        {children}
        <Box
          sx={{
            padding: "16px",
            display: "flex",
            gap: "8px",
            justifyContent: "flex-end",
            position: "sticky",
            bottom: 0,
            backgroundColor: "#fff",
            zIndex: 1,
          }}
        >
          {yesNo && (
            <>
              <Button
                name={noButtonName}
                variant="outlined"
                disabled={buttonsDisabled}
                sx={{ fontWeight: "bold", width: "80px" }}
                onClick={handleClickNo}
              >
                いいえ
              </Button>
              <Button
                name={yesButtonName}
                variant="contained"
                disabled={buttonsDisabled || yesButtonDisabled}
                sx={{ fontWeight: "bold", width: "80px" }}
                onClick={handleClickYes}
              >
                はい
              </Button>
            </>
          )}
        </Box>
      </Dialog>
    </React.Fragment>
  );
};

export default PopoverCustom;
